export default __webpack_public_path__ + "static/media/PUBLI_2_ORG_16.c66957f0.png";